import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../config";
import Ads1Component from "../ads/Ads1";
import {
  Box,
  Container,
  Typography,
  Grid,
 
  Button,

  IconButton,

} from "@mui/material";
import { ArrowBack,AutoStories } from "@mui/icons-material";

const SubjectTheoryPage = () => {
  const navigate = useNavigate();
  const { examId } = useParams();

  const [subjectsData, setSubjectsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");

  const filteredData = (subjectsData ?? []).filter(
    (item) =>
      item.type === "category" ||
      item.name?.toLowerCase().includes(search.toLowerCase())
  );

  const fetchSubjectsData = useCallback(async () => {
    try {
      const tokenString = localStorage.getItem("authToken");
      if (tokenString) {
        const token = JSON.parse(tokenString);

        const response = await fetch(
          `${API_URL}/theory-subjects/${examId}/subjects`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token.access}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          console.log("Subjects Data:", data);
          if (data && data.theory_subjects) {
            setSubjectsData(data.theory_subjects);
          } else {
            setSubjectsData([]);
          }
        } else {
          console.error("Error fetching subjects data:", response.statusText);
          setError("Failed to load subjects");
        }
      }
    } catch (error) {
      console.error("Error fetching subjects data:", error);
      setError("Failed to load subjects");
    } finally {
      setIsLoading(false);
    }
  }, [examId]);

  useEffect(() => {
    fetchSubjectsData();
  }, [fetchSubjectsData]);

  const handleSubjectClick = (theorySubjectId) => {
    navigate(`/theory-years/${examId}/${theorySubjectId}`);
  };

 const TINTS = [
   {
     bg: "linear-gradient(135deg,#ede9fe,#ddd6fe)",
     glow: "rgba(99,60,180,0.12)",
   },
   {
     bg: "linear-gradient(135deg,#fce7f3,#fbcfe8)",
     glow: "rgba(236,72,153,0.1)",
   },
   {
     bg: "linear-gradient(135deg,#dcfce7,#bbf7d0)",
     glow: "rgba(34,197,94,0.1)",
   },
   {
     bg: "linear-gradient(135deg,#fff7ed,#fed7aa)",
     glow: "rgba(249,115,22,0.1)",
   },
   {
     bg: "linear-gradient(135deg,#e0f2fe,#bae6fd)",
     glow: "rgba(14,165,233,0.1)",
   },
   {
     bg: "linear-gradient(135deg,#fef9c3,#fde68a)",
     glow: "rgba(234,179,8,0.1)",
   },
 ];


 
return (
  <Box
    sx={{
      minHeight: "100vh",
      bgcolor: "#f8f7f4",
      fontFamily: "'Sora',sans-serif",
      color: "#1a1a2e",
      backgroundImage:
        "linear-gradient(rgba(99,60,180,0.035) 1px,transparent 1px),linear-gradient(90deg,rgba(99,60,180,0.035) 1px,transparent 1px)",
      backgroundSize: "44px 44px",
    }}
  >
    {/* ── HEADER ── */}
    <Box
      sx={{
        position: "relative",
        bgcolor: "#fff",
        borderBottom: "1px solid rgba(26,26,46,0.07)",
        px: { xs: 2.5, md: 4 },
        pt: "3px",
        pb: 0,
      }}
    >
      {/* Animated top stripe */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          background: "linear-gradient(90deg,#633cb4,#a855f7,#e879f9,#633cb4)",
          backgroundSize: "300% 100%",
          animation: "stripe 4s linear infinite",
          "@keyframes stripe": { to: { backgroundPosition: "-300% 0" } },
        }}
      />

      <Box sx={{ display: "flex", alignItems: "center", gap: 2, py: 2.75 }}>
        <IconButton
          onClick={() => navigate(-1)}
          sx={{
            width: 38,
            height: 38,
            borderRadius: "10px",
            flexShrink: 0,
            border: "1.5px solid rgba(99,60,180,0.2)",
            bgcolor: "rgba(99,60,180,0.05)",
            color: "#633cb4",
            "&:hover": { bgcolor: "rgba(99,60,180,0.12)" },
          }}
        >
          <ArrowBack fontSize="small" />
        </IconButton>

        <Box sx={{ flex: 1 }}>
          <Typography
            sx={{
              fontFamily: "'Sora',sans-serif",
              fontSize: "1.35rem",
              fontWeight: 700,
              color: "#1a1a2e",
              letterSpacing: "-0.02em",
              mb: 0.25,
            }}
          >
            Select Subject
          </Typography>
          <Typography
            sx={{
              fontFamily: "'JetBrains Mono',monospace",
              fontSize: "0.67rem",
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              color: "rgba(26,26,46,0.38)",
            }}
          >
            Choose a subject to start practising
          </Typography>
        </Box>

        {/* Go to Objective button */}
        <Button
          onClick={() => navigate(`/subjects/${examId}`)}
          startIcon={<AutoStories sx={{ fontSize: "16px !important" }} />}
          sx={{
            fontFamily: "'Sora',sans-serif",
            fontSize: "0.8rem",
            fontWeight: 600,
            color: "#633cb4",
            border: "1.5px solid rgba(99,60,180,0.25)",
            borderRadius: "10px",
            px: 2,
            py: 1,
            bgcolor: "rgba(99,60,180,0.05)",
            flexShrink: 0,
            whiteSpace: "nowrap",
            "&:hover": {
              bgcolor: "rgba(99,60,180,0.1)",
              borderColor: "rgba(99,60,180,0.4)",
            },
          }}
        >
          Objective
        </Button>
      </Box>
    </Box>

    <Container maxWidth="lg" sx={{ py: 3, px: { xs: 2, md: 3 } }}>
      {/* Ads */}
      <Box
        sx={{
          borderRadius: "14px",
          overflow: "hidden",
          mb: 2.5,
          border: "1px solid rgba(26,26,46,0.07)",
          boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        }}
      >
        <Ads1Component />
      </Box>

      {/* Search bar */}
      <Box sx={{ position: "relative", mb: 2.5 }}>
        <Box
          sx={{
            position: "absolute",
            left: 12,
            top: "50%",
            transform: "translateY(-50%)",
            fontSize: "14px",
            color: "rgba(26,26,46,0.35)",
            pointerEvents: "none",
          }}
        >
          🔍
        </Box>
        <Box
          component="input"
          placeholder="Search subjects…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{
            width: "100%",
            pl: "36px",
            pr: 2,
            py: 1.25,
            borderRadius: "10px",
            border: "1.5px solid rgba(26,26,46,0.1)",
            bgcolor: "#fff",
            fontFamily: "'Sora',sans-serif",
            fontSize: "0.85rem",
            color: "#1a1a2e",
            outline: "none",
            boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
            transition: "all 0.2s",
            "&:focus": {
              borderColor: "#a855f7",
              boxShadow: "0 0 0 3px rgba(168,85,247,0.1)",
            },
            "&::placeholder": { color: "rgba(26,26,46,0.3)" },
          }}
        />
      </Box>

      {/* Loading */}
      {isLoading && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            py: 14,
            gap: 2,
          }}
        >
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              border: "2.5px solid rgba(99,60,180,0.12)",
              borderTopColor: "#a855f7",
              animation: "spin 0.9s linear infinite",
              "@keyframes spin": { to: { transform: "rotate(360deg)" } },
            }}
          />
          <Typography
            sx={{
              fontFamily: "'JetBrains Mono',monospace",
              fontSize: "0.68rem",
              letterSpacing: "0.15em",
              textTransform: "uppercase",
              color: "rgba(99,60,180,0.4)",
            }}
          >
            Loading subjects
          </Typography>
        </Box>
      )}

      {/* Error */}
      {error && (
        <Box
          sx={{
            p: 2,
            mb: 3,
            borderRadius: "12px",
            bgcolor: "rgba(239,68,68,0.06)",
            border: "1px solid rgba(239,68,68,0.2)",
            color: "#dc2626",
            fontSize: "0.88rem",
          }}
        >
          {error}
        </Box>
      )}

      {/* Empty state */}
      {!isLoading && !error && !subjectsData && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            py: 10,
            gap: 1.25,
            textAlign: "center",
          }}
        >
          <Typography sx={{ fontSize: "3.5rem", mb: 0.5 }}>🔭</Typography>
          <Typography
            sx={{ fontSize: "1.1rem", fontWeight: 700, color: "#1a1a2e" }}
          >
            Coming Soon
          </Typography>
          <Typography sx={{ fontSize: "0.82rem", color: "rgba(26,26,46,0.4)" }}>
            We're working hard to add more subjects
          </Typography>
          <Button
            onClick={() => navigate(-1)}
            startIcon={<ArrowBack />}
            sx={{
              mt: 1,
              fontFamily: "'Sora',sans-serif",
              fontSize: "0.82rem",
              fontWeight: 600,
              color: "#633cb4",
              border: "1.5px solid rgba(99,60,180,0.25)",
              borderRadius: "10px",
              px: 2.5,
              py: 1,
              bgcolor: "rgba(99,60,180,0.06)",
              "&:hover": { bgcolor: "rgba(99,60,180,0.1)" },
            }}
          >
            Go Back
          </Button>
        </Box>
      )}

      {/* Subjects list */}
      {!isLoading &&
        !error &&
        subjectsData &&
        (() => {
          let subjectIndex = 0;
          const currentGrid = [];
          const output = [];

          filteredData.forEach((item, idx) => {
            if (item.type === "category") {
              if (currentGrid.length > 0) {
                output.push(
                  <Grid
                    container
                    spacing={1.5}
                    key={`grid-${idx}`}
                    sx={{ mb: 0.5 }}
                  >
                    {[...currentGrid]}
                  </Grid>
                );
                currentGrid.length = 0;
              }
              output.push(
                <Box
                  key={`cat-${idx}`}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    my: 3,
                  }}
                >
                  <Box
                    sx={{
                      flex: 1,
                      height: "1px",
                      bgcolor: "rgba(26,26,46,0.08)",
                    }}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.75,
                      px: 1.75,
                      py: 0.75,
                      borderRadius: "99px",
                      border: "1px solid rgba(99,60,180,0.15)",
                      background:
                        "linear-gradient(135deg,rgba(99,60,180,0.08),rgba(168,85,247,0.05))",
                    }}
                  >
                    <Box
                      sx={{
                        width: 5,
                        height: 5,
                        borderRadius: "50%",
                        bgcolor: "#633cb4",
                      }}
                    />
                    <Typography
                      sx={{
                        fontFamily: "'JetBrains Mono',monospace",
                        fontSize: "0.65rem",
                        letterSpacing: "0.14em",
                        textTransform: "uppercase",
                        color: "#633cb4",
                        fontWeight: 600,
                      }}
                    >
                      {item.name}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      flex: 1,
                      height: "1px",
                      bgcolor: "rgba(26,26,46,0.08)",
                    }}
                  />
                </Box>
              );
            } else {
              const tint = TINTS[subjectIndex % TINTS.length];
              const delay = `${(subjectIndex % 9) * 0.04}s`;
              subjectIndex++;

              currentGrid.push(
                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={3}
                  key={idx}
                  sx={{ display: "flex" }}
                >
                  <Box
                    onClick={() => handleSubjectClick(item.id)}
                    sx={{
                      width: "100%",
                      bgcolor: "#fff",
                      border: "1.5px solid rgba(26,26,46,0.09)",
                      borderRadius: "16px",
                      overflow: "hidden",
                      cursor: "pointer",
                      display: "flex",
                      flexDirection: "column",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                      transition: "all 0.25s cubic-bezier(0.4,0,0.2,1)",
                      animation: `cardIn 0.4s ${delay} ease both`,
                      "@keyframes cardIn": {
                        from: {
                          opacity: 0,
                          transform: "translateY(12px) scale(0.96)",
                        },
                        to: { opacity: 1, transform: "translateY(0) scale(1)" },
                      },
                      "&:hover": {
                        transform: "translateY(-6px)",
                        boxShadow: "0 14px 36px rgba(99,60,180,0.13)",
                        borderColor: "rgba(99,60,180,0.3)",
                      },
                      "&:hover .card-glow": { opacity: 1 },
                      "&:hover .card-chip": {
                        bgcolor: "rgba(99,60,180,0.1)",
                        borderColor: "rgba(99,60,180,0.35)",
                      },
                    }}
                  >
                    {/* Colour band */}
                    <Box
                      sx={{
                        height: 88,
                        background: tint.bg,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "2.2rem",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <Box
                        className="card-glow"
                        sx={{
                          position: "absolute",
                          inset: 0,
                          opacity: 0,
                          transition: "opacity 0.25s",
                          background: `radial-gradient(ellipse at 50% 50%,${tint.glow},transparent 70%)`,
                        }}
                      />
                      {item.icon ?? "📖"}
                    </Box>

                    {/* Body */}
                    <Box
                      sx={{
                        p: "12px 14px 14px",
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "'Sora',sans-serif",
                          fontSize: "0.88rem",
                          fontWeight: 700,
                          color: "#1a1a2e",
                          lineHeight: 1.25,
                        }}
                      >
                        {item.name}
                      </Typography>
                      <Box
                        className="card-chip"
                        sx={{
                          alignSelf: "flex-start",
                          fontFamily: "'JetBrains Mono',monospace",
                          fontSize: "0.58rem",
                          fontWeight: 600,
                          letterSpacing: "0.08em",
                          textTransform: "uppercase",
                          px: 1.25,
                          py: 0.4,
                          borderRadius: "99px",
                          border: "1px solid rgba(99,60,180,0.2)",
                          bgcolor: "rgba(99,60,180,0.06)",
                          color: "#633cb4",
                          transition: "all 0.2s",
                        }}
                      >
                        Start Practice
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              );
            }
          });

          // flush remaining cards
          if (currentGrid.length > 0) {
            output.push(
              <Grid container spacing={1.5} key="grid-last">
                {[...currentGrid]}
              </Grid>
            );
          }

          return <Box>{output}</Box>;
        })()}
    </Container>
  </Box>
);
};

export default SubjectTheoryPage;
